import { render, staticRenderFns } from "./CategoriasPedidoFornecedor.vue?vue&type=template&id=c943450c&scoped=true"
import script from "./CategoriasPedidoFornecedor.vue?vue&type=script&lang=js"
export * from "./CategoriasPedidoFornecedor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c943450c",
  null
  
)

export default component.exports